
export default function ContactInfo() {
  return (
    <div className="mb-12">
      <h2 className="text-3xl font-bold mb-6 text-gray-900">Get in Touch</h2>
      <p className="text-lg text-gray-600 mb-8 leading-relaxed">
        Whether you're looking for creative direction, photography services, or fine art pieces, 
        I'm here to bring your vision to life. Let's collaborate and create something extraordinary together.
      </p>

      <div className="space-y-6">
        <div className="flex items-start">
          <div className="w-12 h-12 flex items-center justify-center bg-gray-900 text-white rounded-lg mr-4 flex-shrink-0">
            <i className="ri-mail-line text-xl"></i>
          </div>
          <div>
            <h3 className="font-semibold text-gray-900 mb-1">Email</h3>
            <a href="mailto:fdyphoto@gmail.com" className="text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
              fdyphoto@gmail.com
            </a>
          </div>
        </div>

        <div className="flex items-start">
          <div className="w-12 h-12 flex items-center justify-center bg-gray-900 text-white rounded-lg mr-4 flex-shrink-0">
            <i className="ri-map-pin-line text-xl"></i>
          </div>
          <div>
            <h3 className="font-semibold text-gray-900 mb-1">Location</h3>
            <p className="text-gray-600">
              El Monte, California
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
